import { render } from "./BaseImage.vue?vue&type=template&id=d8f89fec"
import script from "./BaseImage.vue?vue&type=script&lang=js"
export * from "./BaseImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BaseImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8f89fec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8f89fec', __exports__)) {
    api.reload('d8f89fec', __exports__)
  }
  
  module.hot.accept("./BaseImage.vue?vue&type=template&id=d8f89fec", () => {
    api.rerender('d8f89fec', render)
  })

}


export default __exports__